import { CompanyInsertedCalendarEventResponse } from '@/types/service-response'

export class EventList {
  private constructor (
    readonly id: number,
    readonly eventName: string
  ) {}

  public static createListFromResponse (data: Array<CompanyInsertedCalendarEventResponse>): Array<EventList> {

    return data.map((item: CompanyInsertedCalendarEventResponse) => {
      return new EventList(
        item.KalenderArtID,
        item.KalenderArtName,
      )
    })
  }
}
